module.exports = __webpack_public_path__ + "img/maestro.b47ccaf1.svg";